import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CircularProgress from '@mui/material/CircularProgress';

import { RotatingIcon } from '../../constants/styledComponents';

export const getStatusTextKey = (healthStatus, upKey, downKey) => {
  switch (healthStatus) {
    case 'up':
      return upKey;
    case 'down':
      return downKey;
    case 'starting':
      return 'settings.deviceStatus.starting';
    case 'checking':
    default:
      return 'settings.deviceStatus.checking';
  }
};

export const getStatusTypographyStyle = (status, theme) => ({
  color:
    status === 'down'
      ? theme.palette.error.main
      : status === 'starting'
        ? theme.palette.warning.main
        : status === 'checking'
          ? theme.palette.info.main
          : theme.palette.primary.main,
});

export const getStatusIcon = (healthStatus, theme, circleSize, progress) => {
  const statusStyle = getStatusTypographyStyle(healthStatus, theme);

  switch (healthStatus) {
    case 'up':
      return <CheckCircleIcon style={{ fontSize: circleSize, ...statusStyle }} />;
    case 'down':
      return <ErrorIcon style={{ fontSize: circleSize, ...statusStyle }} />;
    case 'starting':
      return (
        <CircularProgress
          variant="determinate"
          value={progress}
          style={{ color: statusStyle.color }}
          size={circleSize - 2}
        />
      );
    case 'checking':
      return <RotatingIcon style={{ fontSize: circleSize, ...statusStyle }} />;
    default:
      return <AutorenewIcon style={{ fontSize: circleSize, ...statusStyle }} />;
  }
};

export const getColor = (theme, value) => {
  switch (value) {
    case 'healthy':
      return theme.palette.primary.main;
    case 'starting':
      return theme.palette.warning.main;
    default:
      return theme.palette.error.main;
  }
};

export const getRowBackground = (theme, index) => {
  return index % 2 === 0 ? theme.palette.background.common : theme.palette.background.paper;
};
